jQuery(document).ready(function ($) {

	$(".js-submit").on("click", function (e) {
		const $this = $(this),
			form = $this.closest("form"),
			formData = serializeToPlainObject(form);

		form.removeClass("errors").find(".is-error").removeClass("is-error");

		if ($this.prop("disabled")) {
			return false;
		}

		$.ajax({
			url: creditscore.ajax_url,
			method: "POST",
			data: {
				action: "creditscore",
				nonce: formData.creditscore,
				data: formData,
			},
			beforeSend: function () {
				$this.prop("disabled", true);
			},
			success: function (response) {

				$this.prop("disabled", false);

				if (response.success === false) {
					displayErrors(form, response.data.message);

					$.each(response.data.fields, function () {
						$("input[name=\"" + this + "\"]").closest(".flex-form__row, .flex-form__column").addClass("is-error");
					});
				} else if (response.data.link) {
					setCookie("reference_" + response.data.reference, response.data.check, 1);
					setCookie("email", response.data.email, 1);
					setCookie("initials", response.data.initials, 1);
					setCookie("lastName", response.data.lastName, 1);
					setCookie("gender", response.data.gender, 1);
					setCookie("settings", response.data.settings, 1);

					window.location = response.data.link;
				}
			},
		});

		return false;
	});

	function serializeToPlainObject(formElement) {
		const formDataArray = $(formElement).serializeArray(),
			formDataObject = {};

		formDataArray.forEach(function (item) {
			formDataObject[item.name] = item.value;
		});

		return formDataObject;
	}

	function displayErrors(form, error) {
		let errorContainer = form.find(".flex-form__errors");

		if (!errorContainer.length) {
			form.append("<div class=\"flex-form__errors\"></div>");
			errorContainer = form.find(".flex-form__errors");
		}

		errorContainer.html($("<p class=\"error-message\"></p>").text(error));

		form.addClass("errors");
	}
});